var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1562 16.0098V25.6764M8.1562 25.6764H6.34375M8.1562 25.6764H9.96875",
    stroke: "white",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8438 16.0098V25.6764M20.8438 25.6764H19.0312M20.8438 25.6764H22.6563",
    stroke: "white",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15625 5.43685V3.32227",
    stroke: "white",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8438 5.43685V3.32227",
    stroke: "white",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64453 15.7077L10.2695 6.04102",
    stroke: "white",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7305 15.7077L22.3555 6.04102",
    stroke: "white",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 15.7077L16.3125 6.04102",
    stroke: "white",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32422 9.36523C3.32422 7.36321 4.94719 5.74023 6.94922 5.74023H22.0534C24.0555 5.74023 25.6784 7.36321 25.6784 9.36523V12.3861C25.6784 14.3882 24.0555 16.0111 22.0534 16.0111H6.94922C4.94719 16.0111 3.32422 14.3882 3.32422 12.3861V9.36523Z",
    fill: "white",
    fillOpacity: 0.45,
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceRequest);
export default __webpack_public_path__ + "static/media/service-request.33fd56e22b407b6bd0ed348b4b91b858.svg";
export { ForwardRef as ReactComponent };